"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseProvider = void 0;
const React = require("react");
class BaseProvider {
    constructor(provider) {
        this.provider = provider;
    }
    component(children) {
        return React.createElement(React.Fragment, null, children);
    }
    onRender(htmlPage) {
        return htmlPage;
    }
}
exports.BaseProvider = BaseProvider;
//# sourceMappingURL=BaseProvider.js.map